<template>
  <page>
    <page-poster-with-image
      :headline="$t('problems.poster.headline', { class: $style['problems-poster-first-word'] })"
      :paragraph="$t('problems.poster.paragraph')"
      src="/img/posters/problemsPoster.png"
      :alt="$t('data.magnet')"
    />
    <problems-items />
    <page-info-footer-row />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePosterWithImage from '@/components/common/PagePosterWithImage.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import ProblemsItems from '@/components/problems/ProblemsItems.vue';

export default {
  components: {
    Page,
    PagePosterWithImage,
    PageInfoFooterRow,
    ProblemsItems,
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/styles/colors';

.problems-poster-first-word {
  color: $red;
}
</style>
